<div class="notification-container">
  @for (item of notifications; track item) {
    <div class="notification notification--{{item.type}}" [@enterAnimation]
      (keydown)="dismissNotification(item.id)" (click)="dismissNotification(item.id)">
      <div class="notification__content">
        @if (item.config.title) {
          <h2 class="notification__title">
            {{item.config.title | l10n}}
          </h2>
        }
        <div class="notification__message">{{ item.message | l10n }}</div>
      </div>
      @if (item.config.action) {
        <button class="notification__action" (click)="handleActionClick($event, item)">
          {{item.config.action.label | l10n}}
        </button>
      }
      <span class="notification__close"></span>
    </div>
  }
</div>

